import dialNumber from "./dialNumber"

export default dialNumber
